define([
    "dojo/_base/declare",
    "csi/breadcrumb/StateActionController",
    "csi/reflection",
    "csi/config",
    "csi/locale",
    "csi/widget/MessageDialog",
    "csi/xml"
], function(declare,StateActionController,reflection,csiConfig,locale,MessageDialog,xml) {

    return declare(StateActionController, {
        showCopyCanvasConfirm: false,
        userRespCopyCanvasToNewRevision: false,

        hasToConfirmAction: function() {
            var copyBehaviorLocked = csiConfig.getNodeSetting(this.getParent(), "CopyBehaviorLocked");
            var parentType = this.getParent().$Type;
            var isPages = this.getNode().Pages && this.getNode().Pages.length > 0;

            var rc = reflection.getClass(parentType);
            var isDataSheet = rc.isDerivedFrom("DataSheet");

            this.showCopyCanvasConfirm = isDataSheet && !copyBehaviorLocked && isPages;
            return this.showCopyCanvasConfirm;
        },

        confirmAction: function(params) {
            if (this.showCopyCanvasConfirm) {
                var copyCanvasOnRevise = csiConfig.getNodeSetting(this.getParent(), "CopyCanvasOnRevise");
                var copyCanvButton = MessageDialog.BUTTON_COPYCANVAS + (copyCanvasOnRevise ? MessageDialog.BUTTON_PRIMARY : "");
                var contNoCopyButton = MessageDialog.BUTTON_CONTWOCOPY + (!copyCanvasOnRevise ? MessageDialog.BUTTON_PRIMARY : "");

                StateActionController.prototype.confirmAction.call(this, {
                    materialIcon: MessageDialog.ICON_WARNING,
                    title: locale.resource("Copy_CanvasPage_Title"),
                    buttons: [copyCanvButton, contNoCopyButton],
                    message: locale.resource("Copy_CanvasPage_Message")
                });
            } else {
                this.inherited(arguments);
            }
        },

        onConfirm: function(/*String*/key) {
            // summary: if configured to confirm action, then start now that confirmed
            if (key == MessageDialog.BUTTON_CANCEL) {
                this.postProcess();
            } else {
                this.userRespCopyCanvasToNewRevision = (key == MessageDialog.BUTTON_COPYCANVAS);
                this.preProcess();
            }
        },

        toWriter: function() {
            var copyBehaviorLocked = csiConfig.getNodeSetting(this.getParent(), "CopyBehaviorLocked");
            var copyCanvasOnRevise = csiConfig.getNodeSetting(this.getParent(), "CopyCanvasOnRevise");

            if ((this.showCopyCanvasConfirm &&
                    !this.userRespCopyCanvasToNewRevision) // from confirm dialog
                    || (copyBehaviorLocked && !copyCanvasOnRevise)) {  // no confirm dialog
                var parentType = this.getParent().$Type;
                var operationName;

                if (parentType == "TestRun") {
                    operationName = "ReviseOptionalCanvas";
                } else {
                    // when revise is available, node is not frozen, if reopen is available, node is frozen
                    operationName = xml.nodeIsFrozen(this.getNode()) ? "ReopenPhaseOptionalCanvas" : "ReviseAndAbandonOptionalCanvas";
                }

                this.m_writer.callMethod("SiteAdmin", operationName)
                    .addParameter(xml.PROP_URL, xml.ATTR_REF, this.m_urlNode)
                    .addParameter("isCopyCanvas", xml.ATTR_BOOLEAN, false);
            } else {
                this.inherited(arguments);
            }
        }
    });
});